import Navbar from 'components/navbar';
import SupplierForecastSearchBar from 'components/Searchbar/SupplierForecastSearchBar';
import { Outlet } from 'react-router-dom';
import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

const SupplierForecastHoc = () => {
  const {
    SupplierForecastStore: { resetStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetStore();
    };
  }, [resetStore]);

  return (
    <div>
      <div>
        <Navbar
          heading="FDP - Supplier Forecast"
          searchComponent={<SupplierForecastSearchBar />}
          progressComponent={<></>}
        />
        <Outlet />
      </div>
    </div>
  );
};

export default SupplierForecastHoc;
